import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Button } from 'foundations-components/transitional/components/Button';
import { CardWrapper } from 'foundations-components/transitional/components/Card';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const InteractiveContentError = ({
  title,
  handleRetry,
  errorMessage
}) => {
  return /*#__PURE__*/_jsxs(View, {
    paddingBlockEnd: "1000",
    paddingBlockStart: "0",
    paddingInline: "1300",
    children: [/*#__PURE__*/_jsx(Text, {
      as: "h2",
      marginBlock: "500",
      children: title
    }), /*#__PURE__*/_jsx(CardWrapper, {
      children: /*#__PURE__*/_jsxs(ErrorMessage, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.interactiveEducation.errors.title"
        }),
        type: "badRequest",
        children: [errorMessage && /*#__PURE__*/_jsx(Text, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: errorMessage
          })
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.interactiveEducation.errors.description"
        }), /*#__PURE__*/_jsx(Button, {
          onClick: handleRetry,
          use: "tertiary",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.interactiveEducation.errors.tryAgain"
          })
        })]
      })
    })]
  });
};
export default InteractiveContentError;